import { Component, Input, OnInit } from '@angular/core';
import { InboundFax } from '../../../core/models/inbound-fax.model';
import { keyedReasonOptions } from '../../../core/options/inbound-fax-status-reasons.opts';
import { OutboundFaxStatus } from '../../../core/enums/outbound-fax-status.enum';
import { keyedStatusOptions as keyedProviderOfficeStatusOptions } from 'app/core/options/provider-office-status.opts';
import { PatientNameComponent } from '../../../shared/components/patient-name/patient-name.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { DatePipe } from '@angular/common';
import { OfficeComponent } from '../../../shared/components/office/office.component';
import { BlankValueDashComponent } from '../../../shared/components/blank-value-dash/blank-value-dash.component';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { InboundFaxCapturesComponent } from '../inbound-fax-captures/inbound-fax-captures.component';

@Component({
    selector: 'app-inbound-fax-view-processed',
    templateUrl: './inbound-fax-view-processed.component.html',
    imports: [PatientNameComponent,
              PrescriberNameComponent,
              OfficeComponent,
              BlankValueDashComponent,
              RouterLinkActive,
              RouterLink,
              InboundFaxCapturesComponent,
              DatePipe]
})
export class InboundFaxViewProcessedComponent implements OnInit {
  keyedReasonOptions = keyedReasonOptions;
  outboundFaxStatuses = OutboundFaxStatus;
  keyedProviderOfficeStatusOptions = keyedProviderOfficeStatusOptions;

  @Input() inboundFax: InboundFax;

  constructor() {}

  ngOnInit() {}
}
